import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_FAMILIARES,
  ALL_FAMILIARES,
  LOADING_ALL_FAMILIARES,
} from './FamiliaresReducer';
import {
  allFamiliaresService,
  asignarFamiliaresService,
  deleteFamiliaresService,
  saveFamiliaresService,
} from './FamiliaresService';

export const allFamiliaresAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_FAMILIARES, payload: true });
    const res = await allFamiliaresService(params);
    dispatch({ type: ALL_FAMILIARES, payload: res.data });
    dispatch({ type: LOADING_ALL_FAMILIARES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_FAMILIARES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const setActivoFamiliaresAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_FAMILIARES, payload: data });
};

export const saveFamiliaresAction = async (
  { dispatch, notify },
  data,
  params,
) => {
  try {
    const res = await saveFamiliaresService(data);
    notify(res.data.message);
    await allFamiliaresAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const asignarFamiliaresAction = async (
  { dispatch, notify },
  data,
  params,
) => {
  try {
    const res = await asignarFamiliaresService(data);
    notify(res.data.message);
    await allFamiliaresAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteFamiliaresAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteFamiliaresService(id);
    notify(res.data.message);
    await setActivoFamiliaresAction(dispatch, null);
    await allFamiliaresAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
